export class PublishOnceEvent<P=any> {
    private Subscribers:{reference:any,callback:(T)=>void}[];
    private WasCalled:boolean;
    private UsedArgs:any;
    constructor() {
        this.WasCalled=false;
        this.Subscribers = [];
    }

    public Subscribe(referentce:any,callback:(T)=>void){
        if(this.Subscribers.find(x=>x.reference==referentce))
            return;
        this.Subscribers.push({reference:referentce,callback:callback});
        if(this.WasCalled)
            callback(this.UsedArgs);
        else
            this.Subscribers.push({reference:referentce,callback:callback});
    }

    public Unsubscribe(reference:any){
        let subscriber=this.Subscribers.find(x=>x.reference==reference);
        if(subscriber==null)
            return;

        this.Subscribers.splice(this.Subscribers.indexOf(subscriber),1);
    }

    public Publish(args?:P)
    {
        this.UsedArgs=args;
        this.WasCalled=true;
        while (this.Subscribers.length>0)
        {
            let subscriber=this.Subscribers.pop();
            subscriber.callback(this.UsedArgs);
        }
    }
}